/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description hook for get guarantors
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import { updateApiParamsCriteria } from 'utils/advancedFilterUtils';
import { GUARANTOR_ADF_FIELD_MAP } from 'utils/adfUtils';

/**
 * useSearchGuarantors
 * @returns {UseQueryResult} useSearchGuarantors
 */
const useSearchGuarantors = (
	requestParams: Guarantor.ISearchAllGuarantors,
	options?: IQueryOptions,
): UseQueryResult<Guarantor.IPaginatedGuarantors, IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.guarantors, requestParams],
		queryFn: async () => {
			const { data } = await api.FHIRAccountApi.searchGuarantors(updateApiParamsCriteria(requestParams, GUARANTOR_ADF_FIELD_MAP));
			return data;
		},
		...options,
	});
};

export default useSearchGuarantors;
